export default __webpack_public_path__ + "static/media/logo.31f3756e.svg";